export const en = {
    'no-rights': 'Insufficient rights to apply the recommendation',
    'progress-title': 'Applying the recommendation'
};
